import { Container, IDestroyOptions } from "@pixi/display";
import { Spine } from "pixi-spine";
import { GameUIResourcesPackage } from "../../../../../preloader/resources/GameUIResourcesPackage";
import { Ticker } from "@pixi/core";

export class BaseBoosterButton extends Container {
    protected highlight: Spine;
    protected timeToHighlightMs: number;
    constructor(protected readonly resources: GameUIResourcesPackage) {
        super();
        this.timeToHighlightMs = this.getRandomInt(20000, 60000);
        Ticker.shared.add(this.onTick, this);
    }

    protected onTick(_deltaMs: number): void {
        this.timeToHighlightMs = Math.max(this.timeToHighlightMs - Ticker.shared.elapsedMS, 0);
        if(this.timeToHighlightMs === 0) {
            this.timeToHighlightMs = this.getRandomInt(15000, 30000);
            this.highlightAnimation();
        }
    }

    protected async highlightAnimation(): Promise<void> {
        return new Promise((resolve) => {
            this.highlight = new Spine((this.resources.assets_game_effects_booster_promotion_booster_promotion_json as any).spineData);
            const animationName = `ad_promotion_${this.getRandomInt(1, 8)}`;
            this.highlight.state.setAnimation(0, animationName, false);
            this.addChild(this.highlight);
            this.highlight.state.addListener({
                complete: () => {
                    requestAnimationFrame(() => {
                        this.highlight.state?.clearListeners();
                        this.removeChild(this.highlight)?.destroy({ children: true });
                        resolve();
                    });
                }
            });
        });
    }

    protected getRandomInt(min: number, max: number): number {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        Ticker.shared.remove(this.onTick, this);
        super.destroy(options);
    }
}